import * as React from 'react';

export const ArrowUpDownLine = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <g clipPath='url(#clip0_5688_18496)'>
      <path
        d='M9.95898 6.625L8.78065 7.80333L6.66732 5.69V16.6667H5.00065V5.69L2.88815 7.80333L1.70898 6.625L5.83398 2.5L9.95898 6.625ZM18.2923 13.375L14.1673 17.5L10.0423 13.375L11.2207 12.1967L13.3348 14.31L13.334 3.33333H15.0007V14.31L17.114 12.1967L18.2923 13.375Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_5688_18496'>
        <rect width={20} height={20} fill='white' />
      </clipPath>
    </defs>
  </svg>
);
